import { render, staticRenderFns } from "./Hora.vue?vue&type=template&id=2ccf21e7&scoped=true"
import script from "./Hora.vue?vue&type=script&lang=js"
export * from "./Hora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf21e7",
  null
  
)

export default component.exports